<template>
    <footer class="tw-bg-white">
      <div class="social-media tw-bg-background">
        <v-container class="tw-pt-10 tw-pb-12 tw-text-center md:tw-text-right">
          <v-btn v-for="(item, index) in socialMedias"
                 :key="index"
                 :href="item.url"
                 target="_blank"
                 icon outlined dark>
            <v-icon>{{ item.icon }}</v-icon>
          </v-btn>
        </v-container>
      </div>
      <div class="signature tw-relative tw-text-center">
        <v-container class="md:tw-flex tw-justify-between">
          <div class="logo">
            <a href="https://www.iu.edu" class="signature-link external one-pan-link-mark">Indiana University</a>
          </div>
          <div class="copyright">
            <a href="/privacy" id="privacy-policy-link" class="one-pan-link-mark">Privacy Notice</a> |
            <a href="https://accessibility.iu.edu/help" id="accessibility-link" title="Having trouble accessing this web page because of a disability? Visit this page for assistance." class="external one-pan-link-mark">
              Accessibility Help
            </a>
            <span v-if="$vuetify.breakpoint.mdAndUp"> | </span>
            <br v-else />
            <a href="https://www.iu.edu/copyright/index.html" class="external one-pan-link-mark">Copyright</a> © 2020
            <span class="line-break-small">The Trustees of <a href="https://www.iu.edu/" class="external one-pan-link-mark"><span itemprop="name">Indiana University</span></a></span>
          </div>
        </v-container>
      </div>
    </footer>
</template>

<script>
export default {
  name: 'DefaultFooter',
  data () {
    return {
      socialMedias: [
        {
          icon: 'mdi-facebook',
          url: 'https://www.facebook.com/ingeosurvey'
        },
        {
          icon: 'mdi-twitter',
          url: 'https://twitter.com/ingeosurvey'
        },
        {
          icon: 'mdi-linkedin',
          url: 'https://www.linkedin.com/company/indiana-geological-survey/'
        },
        {
          icon: 'mdi-instagram',
          url: 'https://www.instagram.com/ingeosurvey/'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .signature {
    text-align: left;
    border-top: 6px solid #7A1705;
    padding-top: 32px;
    padding-bottom: 24px;
  }
  .tagline {
    @apply absolute text-white text-xl uppercase;
    top: -3px;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: BentonSansCondBold, Arial, serif;
    font-weight: normal;
    background: #7A1705;
    font-size: 1.375rem;
    line-height: 2.5rem;
    letter-spacing: 0.2em;
    span {
      text-transform: lowercase;
      font-style: italic;
      font-family: GeorgiaProBoldItalic, Georgia, serif;
      font-size: 1rem;
      vertical-align: 2px;
      letter-spacing: 0;
      margin-left: -4px;
    }
  }
  .logo {
    background: url(../../assets/images/iu-sig-formal.svg) no-repeat left top;
    background-size: contain;
    display: inline-block;
    height: 0;
    padding-top: 36px;
    overflow: hidden;
    width: 240px;
  }
  .copyright {
    font-size: 0.75rem;
    margin: 0;
    line-height: 2.25rem;
    a {
      color: #990000;
    }
  }
</style>
